import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

export const ModificationPowerOverheadForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, submitChange } = useFormModel<
        ChangeNames.MODIFICATION_POWER_OVERHEAD
    >();

    const convertValue = (): string => {
        if (values.modificationPowerOverhead.value.junctionBoxReplacement)
            return "junctionBoxReplacement";
        if (values.modificationPowerOverhead.value.roofPillarReassembly)
            return "roofPillarReassembly";
        if (values.modificationPowerOverhead.value.roofPillarElevation)
            return "roofPillarElevation";
        return "";
    };
    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Freileitung
                </h4>
                <p className={classes.p}>Welche Änderung soll vorgenommen werden?</p>{" "}
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            const newValues = setValues(values => {
                                values.modificationPowerOverhead.value = {
                                    junctionBoxReplacement:
                                        v.indexOf("junctionBoxReplacement") >= 0,
                                    roofPillarReassembly: v.indexOf("roofPillarReassembly") >= 0,
                                    roofPillarElevation: v.indexOf("roofPillarElevation") >= 0,
                                };
                            });
                            submitChange(newValues);
                        }}
                    >
                        <FormControlLabel
                            value="junctionBoxReplacement"
                            control={<Radio />}
                            label="Austausch Hausanschlusskasten"
                            text=""
                            error={values.modificationPowerOverhead.error != null}
                        />
                        <FormControlLabel
                            value="roofPillarReassembly"
                            control={<Radio />}
                            label="Vorübergehender Abbau und Wiedererrichtung eines Dachständers"
                            text=""
                            error={values.modificationPowerOverhead.error != null}
                        />
                        <FormControlLabel
                            value="roofPillarElevation"
                            control={<Radio />}
                            label="Erhöhen eines Dachständers"
                            text=""
                            error={values.modificationPowerOverhead.error != null}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
